import React from "react";
import {
  Form,
  Button,
} from "antd";
import { useDispatch } from "react-redux";
import get from "lodash/get";
import find from "lodash/find";
import assign from "lodash/assign";
import { fetchSingleDevice } from "../../../redux/actions/entityActions";
import GraphInfoForm from "./graphInfoForm";
import templateConfig from "../../../constants/template";


const GraphInfo = ({
  edit,
  entityTree,
  setLoading,
  onSubmitFormValue,
  goToStep,
  initialValues,
  localState,
  setLocalState,
  templateType
}) => {
  const [form] = Form.useForm();
  const dispatch = useDispatch();

  const onFinish = (values) => {
    onSubmitFormValue(values, 2);
  };

  const onSelectDevice = (deviceId, index) => {
    setLoading(true);
    dispatch(fetchSingleDevice(deviceId))
      .then((device) => {
        localState[index] = {
          device,
        };
        setLocalState([...localState]);
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  };

  const onSelectModule = (moduleId, index) => {
    const graph = get(
      { ...form.getFieldsValue() },
      "graph"
    );
    assign(graph[index], {
      event_id: undefined,
    });
    form.setFieldsValue({ graph });
    const module = find(get(localState, `${index}.device.modules`), [
      "id",
      moduleId,
    ]);
    localState[index] = {
      ...localState[index],
      module,
    };
    setLocalState([...localState]);
  };

  const onFinishFailed = () => {};

  return (
    <div>
      <Form
        layout="vertical"
        form={form}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        scrollToFirstError
        initialValues={initialValues}
      >
        <GraphInfoForm templateConfig={templateConfig(templateType)} onSelectDevice={onSelectDevice} onSelectModule={onSelectModule} form={form} entityTree={entityTree} localState={localState}/>
      </Form>
      <div className="w-full bg-white p-4">
        <div className="flex justify-end space-x-2">
          <Button
            onClick={() => {
              goToStep(0);
            }}
            className="border-gray-300"
          >
            Back
          </Button>
          <Button
            type="primary"
            htmlType="submit"
            onClick={() => form.submit()}
          >
            Next
          </Button>
        </div>
      </div>
    </div>
  );
};

export default GraphInfo;